import checkout from "./form";

const {
  formField: {
    taxCalculationPeriod,
    ariseTimes,
    date,
    firstTime,
    supplementaryForThe,
    checkbox1,
    checkbox2,
    taxId1,
    taxpayerName,
    taxpayerName2,
    taxId2,
    address,
    address2,
    district,
    province,
    phone,
    fax,
    email,
    taxAgencyName,
    taxAgencyId,
    certificate,
    fullName,
    signer,
    timeSign,
  },
} = checkout;

const initialValues = {
  [address.name]: "",
  [address2.name]: "",
  [taxpayerName2.name]: "",
  [email.name]: "",
  [fax.name]: "",
  [firstTime.name]: false,
  [checkbox1.name]: false,
  [checkbox2.name]: false,
  [phone.name]: "",
  [supplementaryForThe.name]: "",
  [taxAgencyId.name]: "",
  [taxAgencyName.name]: "",
  [taxCalculationPeriod.name]: "",
  [taxId1.name]: "",
  [taxId2.name]: "",
  [taxpayerName.name]: "",
  [ariseTimes.name]: "",
  [date.name]: "",
  [district.name]: "",
  [province.name]: "",
  [certificate.name]: "",
  [signer.name]: "",
  [fullName.name]: "",
  [timeSign.name]: "",
};

export default initialValues;
